import React from 'react';
import {Trans} from 'react-i18next';
import {ListParagraph} from '../../../shared/list-paragraph/ListParagraph';
import {TransWithNoWrapSpan} from '../../../shared/trans/TransWithNoWrapSpan';

export const WithdrawalReferenceNumberHowTo = () => {
  const bullets = [
    'WITHDRAW.PARTNER_WITHDRAWAL.HOW_TO.POINT_1',
    'WITHDRAW.PARTNER_WITHDRAWAL.HOW_TO.POINT_2',
    'WITHDRAW.PARTNER_WITHDRAWAL.HOW_TO.POINT_3',
    'WITHDRAW.PARTNER_WITHDRAWAL.HOW_TO.POINT_4',
    'WITHDRAW.PARTNER_WITHDRAWAL.HOW_TO.POINT_5'
  ].map(bullet => <TransWithNoWrapSpan>{bullet}</TransWithNoWrapSpan>);

  return <ListParagraph items={bullets} title={<Trans>WITHDRAW.PARTNER_WITHDRAWAL.HOW_TO.TITLE</Trans>} />
};